import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteCardReaderData, getCardReaderDatas,} from "../../../redux/modules/CardReader/action";

class CardReader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getCardReaderDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.cardReader.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const cardReaderColumn = [
            {
                name: "Card Reader",
                path: "name",
                show: true,
            },
            {
                name: "UNUM",
                path: "UNUM",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"CardReader Data"}
                        data={this.props.cardReader.datas}
                        columns={cardReaderColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteCardReaderData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cardReader: state.cardReader,
});

const mapDispatchToProps = {
    getCardReaderDatas,
    deleteCardReaderData,
};

export default MainLayout(connect(mapStateToProps, mapDispatchToProps)(CardReader));
